import BvIcon from 'volta/components/bv-icon';
import BvInline from 'volta/components/bv-inline';
import orElse from 'volta/helpers/or-else';
import tElse from 'volta/helpers/t-else';

import type { TOC } from '@ember/component/template-only';

interface FiltersAlertOptionSignature {
  Args: {
    option: TSelectOption;
  };
  Element: HTMLDivElement;
}

const FiltersAlertOptionComponent: TOC<FiltersAlertOptionSignature> = <template>
  <BvInline @blockAlign='center' @align='space-between' @gap='2' class='u-full-width' ...attributes>
    {{tElse @option.label}}
    <BvIcon @glyph={{orElse @option.icon 'ellipse'}} @color={{@option.color}} />
  </BvInline>
</template>;

export default FiltersAlertOptionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::AlertOption': typeof FiltersAlertOptionComponent;
    'filters/alert-option': typeof FiltersAlertOptionComponent;
  }
}
